var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1258 2.52846C13.3387 0.126424 17.2532 2.4893 16.1588 5.56644L14.9884 8.85717H18.6523C21.2662 8.85717 22.6298 11.9674 20.8587 13.8898L13.874 21.4715C11.6611 23.8736 7.74657 21.5107 8.84103 18.4335L10.0114 15.1429H6.34748C3.73362 15.1429 2.37002 12.0326 4.14107 10.1102L11.1258 2.52846ZM14.2744 4.89623C14.6392 3.87051 13.3344 3.0829 12.5968 3.88357L5.61201 11.4653C5.02166 12.1061 5.47619 13.1429 6.34748 13.1429H11.4285C11.7534 13.1429 12.0581 13.3008 12.2455 13.5663C12.4329 13.8318 12.4796 14.1718 12.3707 14.478L10.7254 19.1038C10.3606 20.1295 11.6654 20.9171 12.403 20.1164L19.3878 12.5347C19.9781 11.8939 19.5236 10.8572 18.6523 10.8572H13.5713C13.2464 10.8572 12.9417 10.6993 12.7543 10.4338C12.5669 10.1682 12.5203 9.82824 12.6291 9.52207L14.2744 4.89623Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapInactive);
export default __webpack_public_path__ + "static/media/zap-inactive.3192ff81dad4ebefd2c0b96e3a7821f5.svg";
export { ForwardRef as ReactComponent };